import * as _4 from 'lodash4';

export class NetworkFailureConfiguration {
  private responseFailures: Record<string, Array<(rejection?: any) => void>>;
  private requestFailures: Array<(rejection?: any) => void>;
  private configuration: Record<string, any>;

  constructor(private $httpProvider: ng.IHttpProvider) {
    this.configuration;
    this.requestFailures = [];
    this.responseFailures = {};
  }

  onRequestFailure(fn: (rejection?: any) => void): this {
    this.requestFailures.push(fn);
    return this;
  }

  onResponseFailure(status: string, fn: (rejection?: any) => void): this {
    this.responseFailures[status] = this.responseFailures[status] || [];
    this.responseFailures[status].push(fn);
    return this;
  }

  configure(userConfig: Record<string, any>): Record<string, any> {
    if (!!userConfig) {
      this.configuration = _4.defaults({}, userConfig);
    }

    return this.configuration;
  }

  activate(userConfig: Record<string, any>): Record<string, any> {
    this.configure(userConfig);

    const self = this;
    this.$httpProvider.interceptors.push(($q: ng.IQService) => {
      return {
        requestError: (rejection: any) => {
          if (!rejection) {
            return $q.defer();
          }

          _4.each(self.requestFailures, (fn: (rejection?: any) => void) => fn(rejection));

          return $q.reject(rejection);
        },
        responseError: (rejection: any) => {
          if (!rejection) {
            return $q.defer();
          }

          _4.each(self.responseFailures[rejection.status], (fn: (rejection?: any) => void) => fn(rejection));

          return $q.reject(rejection);
        }
      };
    });

    return this.configuration;
  }

  $get(): this {
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-configuration/src/configuration/network_failure_configuration.ts